export default "__VITE_ASSET__CmbaMu8l__"